import { action } from 'typesafe-actions';
import { ApplyConfigActionTypes } from './types';
import { IApplyUniConfig } from 'api-paths-cas';

export const getApplyConfigRecord = (uni: string) => action(ApplyConfigActionTypes.GET_APPLY_CONFIG, { uni });
export const getApplyConfigRecordSuccess = (config: IApplyUniConfig) =>
  action(ApplyConfigActionTypes.GET_APPLY_CONFIG_SUCCESS, config);
export const getApplyConfigRecordFailure = (error: string) =>
  action(ApplyConfigActionTypes.GET_APPLY_CONFIG_FAILURE, error);
